// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__25hc4","select":"Header_select__3fxQ1","clinic":"Header_clinic__3jm05"};